import {HttpClient, HttpParams} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {environment} from '@environments/environment';
import {Observable} from 'rxjs';
import {ICategoryListRequestModel} from '../models/category-list-request.model';
import {ICategoryListResponseModel} from '../models/category-list-response.model';

@Injectable({
  providedIn: 'root',
})
export class CategoryListService {
  private readonly _httpClient = inject(HttpClient);

  private readonly getCategoriesUrl = `${environment.api.baseUrl}/${environment.api.checkout.getCategories}`;

  getCategoryList(request: ICategoryListRequestModel): Observable<ICategoryListResponseModel[]> {
    let params = new HttpParams();
    if (request.status) {
      params = params.set('status', request.status);
    }
    return this._httpClient.get<ICategoryListResponseModel[]>(`${this.getCategoriesUrl}/${request.organizationId}`, {
      params,
    });
  }
}
